export * from './src/legacy-crm-adapter';
